/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createValidationToken$Json } from '../fn/validation-token/create-validation-token-json';
import { CreateValidationToken$Json$Params } from '../fn/validation-token/create-validation-token-json';
import { createValidationToken$Plain } from '../fn/validation-token/create-validation-token-plain';
import { CreateValidationToken$Plain$Params } from '../fn/validation-token/create-validation-token-plain';
import { getValidationToken$Json } from '../fn/validation-token/get-validation-token-json';
import { GetValidationToken$Json$Params } from '../fn/validation-token/get-validation-token-json';
import { getValidationToken$Plain } from '../fn/validation-token/get-validation-token-plain';
import { GetValidationToken$Plain$Params } from '../fn/validation-token/get-validation-token-plain';
import { getValidationTokens$Json } from '../fn/validation-token/get-validation-tokens-json';
import { GetValidationTokens$Json$Params } from '../fn/validation-token/get-validation-tokens-json';
import { getValidationTokens$Plain } from '../fn/validation-token/get-validation-tokens-plain';
import { GetValidationTokens$Plain$Params } from '../fn/validation-token/get-validation-tokens-plain';
import { ValidationTokenModel } from '../models/validation-token-model';

@Injectable({ providedIn: 'root' })
export class ValidationTokenService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getValidationTokens()` */
  static readonly GetValidationTokensPath = '/api/ValidationToken';

  /**
   * get all validationtoken.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValidationTokens$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationTokens$Plain$Response(params: GetValidationTokens$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationTokenModel>>> {
    return getValidationTokens$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all validationtoken.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValidationTokens$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationTokens$Plain(params: GetValidationTokens$Plain$Params, context?: HttpContext): Observable<Array<ValidationTokenModel>> {
    return this.getValidationTokens$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationTokenModel>>): Array<ValidationTokenModel> => r.body)
    );
  }

  /**
   * get all validationtoken.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValidationTokens$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationTokens$Json$Response(params: GetValidationTokens$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationTokenModel>>> {
    return getValidationTokens$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all validationtoken.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValidationTokens$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationTokens$Json(params: GetValidationTokens$Json$Params, context?: HttpContext): Observable<Array<ValidationTokenModel>> {
    return this.getValidationTokens$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationTokenModel>>): Array<ValidationTokenModel> => r.body)
    );
  }

  /** Path part for operation `createValidationToken()` */
  static readonly CreateValidationTokenPath = '/api/ValidationToken';

  /**
   * create new validationtoken.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createValidationToken$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createValidationToken$Plain$Response(params?: CreateValidationToken$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
    return createValidationToken$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create new validationtoken.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createValidationToken$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createValidationToken$Plain(params?: CreateValidationToken$Plain$Params, context?: HttpContext): Observable<ValidationTokenModel> {
    return this.createValidationToken$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ValidationTokenModel>): ValidationTokenModel => r.body)
    );
  }

  /**
   * create new validationtoken.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createValidationToken$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createValidationToken$Json$Response(params?: CreateValidationToken$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
    return createValidationToken$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create new validationtoken.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createValidationToken$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createValidationToken$Json(params?: CreateValidationToken$Json$Params, context?: HttpContext): Observable<ValidationTokenModel> {
    return this.createValidationToken$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ValidationTokenModel>): ValidationTokenModel => r.body)
    );
  }

  /** Path part for operation `getValidationToken()` */
  static readonly GetValidationTokenPath = '/api/ValidationToken/{validationTokenId}';

  /**
   * get validationtoken by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValidationToken$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationToken$Plain$Response(params: GetValidationToken$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
    return getValidationToken$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get validationtoken by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValidationToken$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationToken$Plain(params: GetValidationToken$Plain$Params, context?: HttpContext): Observable<ValidationTokenModel> {
    return this.getValidationToken$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ValidationTokenModel>): ValidationTokenModel => r.body)
    );
  }

  /**
   * get validationtoken by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getValidationToken$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationToken$Json$Response(params: GetValidationToken$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
    return getValidationToken$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get validationtoken by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getValidationToken$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getValidationToken$Json(params: GetValidationToken$Json$Params, context?: HttpContext): Observable<ValidationTokenModel> {
    return this.getValidationToken$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ValidationTokenModel>): ValidationTokenModel => r.body)
    );
  }

}
